// BedCardDesktopView.js
import "./BedCardDesktopView.scss"

import React from "react";
import moment from "moment";

import favoriteSvg from "../../common/icons/svg/favorite.svg";
import favoriteSelectedSvg from "../../common/icons/svg/favorite-selected.svg";
import blackDownArrow from "../../common/icons/svg/black-down-arrow.svg";
import blackUpArrow from "../../common/icons/svg/black-up-arrow.svg";
import whiteUpArrow from "../../common/icons/svg/white-up-arrow.svg";
import whiteDownArrow from "../../common/icons/svg/white-down-arrow.svg";
import noPatientInfoIcon from "../../common/icons/svg/no-patient-info-icon.svg";

import {
    ADD,
    REMOVE,
    VIEW_TYPES,
    BED_CARD_VITALS
} from "../../common/constant/common-constants";

import {
    ACTIVE_PARAMETERS,
    PATIENT_TYPE,
    PARAMETER_UNIT_IDS
} from "../../common/ENUMS/PARAMETER_ENUM";

import { MODE } from "../../common/ENUMS/VENTILATOR_MODES_ENUM";
import { alarmBackground } from "../../common/utils/CommonUtils";

const BedCardDesktopView = ({
    props,
    refProp,
    getAlarmPriorityClass,
    handleShowMoreAlarmsClick,
    handleShowMoreVentilatorAlarmsClick,
    showMoreAlarms,
    showMoreVentilatorAlarms,
    ventilatorConnected,
    user_enabled,
    ventilationStatus,
    monitorConnected
}) => {

    return (
        <div
            className={props.config.viewType === VIEW_TYPES.LIST_VIEW
                ? "bedcard-monitor-container left-panel-card"
                : "bedcard-monitor-container"}
            key={props.bedId}
            ref={refProp}
        >
            <div
                className={props.isSelected === props.bedId ?
                    "bedcard-monitor selected-card" : `bedcard-monitor ${(props.bedDetails?.ventilatorId || props?.bedDetails?.Noccarc_patientMonitorId) ? '' : 'disabled'}`}
                onClick={() => props.handleBedClick(props.bedId)}>
                <div className="bed-patient-details">
                    <div className="bed-header">
                        <div className="bed-number">
                            Bed {props.data.bedName}
                        </div>
                        {!props.isFavorite && <div className="icon-container favorite-icon">
                            <img
                                src={favoriteSvg}
                                alt="notification icon"
                                className="fav-icon"
                                onClick={(event) => props.handleFavoriteClick(event, ADD, props.bedId)}
                            />
                        </div>}
                        {props.isFavorite && <div className="icon-container favorite-icon">
                            <img
                                src={favoriteSelectedSvg}
                                alt="favorite icon"
                                className="fav-icon"
                                onClick={(event) => props.handleFavoriteClick(event, REMOVE, props.bedId)}
                            />
                        </div>}
                    </div>
                    <div className="patient-details-wrapper">
                        <div className="patient-details">
                            {props?.patientData?.name ?
                                <>
                                    <div className="patient-name">
                                        {(props?.patientData?.name) || 'Dummy Name'}
                                    </div>
                                    <div className="pipe">
                                        |
                                    </div>
                                    <div className="patient-age">
                                        {(props.patientData && props.patientData.age) || 'Age'}
                                    </div>
                                    <div className="pipe">
                                        |
                                    </div>
                                    <div className="patient-gender">
                                        {(props.patientData && props.patientData.gender) || 'Gender'}
                                    </div>
                                </>
                                :
                                <div className="no-patient-detail-container">
                                    <img src={noPatientInfoIcon} alt="info icon" />
                                    <span>Patient Details not entered.</span>
                                    <span
                                        className="add-patient-btn"
                                        onClick={
                                            (event) => { event.stopPropagation(); props.handleAddPatientClick(event) }
                                        }
                                    >
                                        Add Patient
                                    </span>
                                </div>
                            }
                        </div>
                        <>
                            {props?.bedDetails?.Noccarc_patientMonitorId?.split('-')[2]}
                        </>
                    </div>
                    <div className={monitorConnected && props?.bedDetails?.Noccarc_patientMonitorId ? '' : 'not-connected'}>
                        {monitorConnected && props?.alarmData?.length > 0 ?
                            <div className={`alarm-container ${getAlarmPriorityClass(props.alarmData[0])}`}
                                onClick={(event) => handleShowMoreAlarmsClick(event)}
                                id="alarm-display-bar"
                            >
                                <div className="top-alarm-container">
                                    {props.alarmData[0].message}
                                </div>
                                <div className="alarm-number-container">
                                    {props.alarmData.length}
                                    {showMoreAlarms ?
                                        <img src={props.alarmData[0]?.priority?.toLocaleUpperCase() === "HIGH" ? whiteUpArrow : blackUpArrow} className="arrow-icon" alt="white up arrow" />
                                        :
                                        <img src={props.alarmData[0]?.priority?.toLocaleUpperCase() === "HIGH" ? whiteDownArrow : blackDownArrow} className="arrow-icon" alt="white down arrow" />
                                    }
                                </div>
                                {showMoreAlarms &&
                                    <div className="more-alarm-container">
                                        {
                                            props?.alarmData?.map((alarm, count) => {
                                                if (count > 3) return;
                                                return (
                                                    <div className="alarm more-alarm" key={count}>
                                                        {`${alarm.message}: ${alarm.value != null ? alarm.value : ''}`}
                                                        <span className="alarm-time">{alarm.time && moment(alarm.time).format("HH:mm:ss")}</span>
                                                    </div>);
                                            })
                                        }
                                        <div className="see-all-container" onClick={() => props.handleAlarmMoreClick()}>
                                            See all
                                        </div>
                                    </div>
                                }
                            </div>
                            :
                            <div className="alarm-container no-alarm"
                                id="no-alarm-display-bar"
                            >
                                <div className="top-alarm-container">
                                    No active alarms
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className={`device-monitor-data ${props?.bedDetails?.Noccarc_patientMonitorId ? '' : 'not-connected'}`}>
                    {
                        BED_CARD_VITALS.MONITOR?.map((vital) => {
                            return (
                                <div

                                    className={`vital-data-detail ${vital.name === 'BP' ? "wide-field" : ""} ${monitorConnected ? alarmBackground(
                                        (() => {
                                            if (vital.label === "RR" || vital.label === "HR") {
                                                return props.vitalData_ECG?.[vital.id]?.alarms;
                                            }
                                            else if (vital.label === "SPO2") {
                                                return props.vitalData_SPO2?.[vital.id]?.alarms;
                                            } else if (vital.label === "TEMP") {

                                                if (props.vitalData_TEMP?.[vital.id]?.value) {
                                                    return props.vitalData_TEMP?.[vital.id]?.alarms
                                                }
                                                else if (props.vitalData_TEMP?.[vital.backup_id]?.value) {
                                                    return props.vitalData_TEMP?.[vital.backup_id]?.alarms
                                                }

                                            } else if (vital.label === "NIBP") {


                                                const sysAlarms = props.vitalData_NIBP?.[vital.sys_id]?.alarms || [];
                                                const diaAlarms = props.vitalData_NIBP?.[vital.dia_id]?.alarms || [];
                                                const meanAlarms = props.vitalData_NIBP?.[vital.mean_id]?.alarms || [];
                                                return [
                                                    ...sysAlarms,
                                                    ...diaAlarms,
                                                    ...meanAlarms
                                                ];


                                            }
                                            return null; // Fallback if no matching label
                                        })()) : ""}`}
                                    key={vital.name}

                                >
                                    <div className="vital-name">
                                        {vital.label}
                                    </div>
                                    <div className="vital-data">
                                        {monitorConnected && props?.monitorHeartBeatData ? (
                                            (() => {
                                                if (vital.label === "RR" || vital.label === "HR") {
                                                    return props.vitalData_ECG?.[vital.id]?.value ?? "-";
                                                    // return "98"
                                                }

                                                else if (vital.label === "SPO2") {
                                                    return props.vitalData_SPO2?.[vital.id]?.value ?? "-"
                                                    // return "98"

                                                }
                                                else if (vital.label === "TEMP") {
                                                    if (props.vitalData_TEMP?.[vital.id]?.value) {
                                                        return props.vitalData_TEMP?.[vital.id]?.value
                                                            ? props.vitalData_TEMP[vital.id].value.toFixed(1)
                                                            : "-"
                                                        // return "98"
                                                    } else {
                                                        return props.vitalData_TEMP?.[vital.backup_id]?.value
                                                            ? props.vitalData_TEMP[vital.backup_id].value.toFixed(1)
                                                            : "-"
                                                        // return "98"

                                                    }


                                                }
                                                else if (vital.label === "NIBP") {
                                                    return `${props.vitalData_NIBP?.[vital.sys_id]?.value ?? "-"}/${props.vitalData_NIBP?.[vital.dia_id]?.value ?? "-"}`
                                                    // return "120/98"
                                                }
                                                return null;
                                            })()
                                        ) : (
                                            '-'
                                        )}

                                        <span className="unit">{vital.unit}</span>

                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                <div className='device-ventilator-data-wrapper'>
                    <div className="ventilator-mode">
                        <div className="flex-alignCenter">
                            Ventilator : {ventilatorConnected && user_enabled && MODE[props?.ventilatorPatientModeAlarmProfileData?.modeId]?.modeName + ' ' + PATIENT_TYPE[props?.ventilatorPatientModeAlarmProfileData?.patientType]}
                        </div>
                        {props?.bedDetails?.ventilatorId ?
                            <div className="flex-alignCenter">
                                {props?.bedDetails?.ventilatorId?.substr(-5)}
                                <div className={`dot ${ventilatorConnected && user_enabled ? (ventilationStatus ? 'connected' : 'standby') : 'disconnected'}`} />
                            </div>
                            :
                            <div>Not connected</div>
                        }
                    </div>
                    <div className={props?.bedDetails?.ventilatorId ? '' : 'not-connected'}>
                        {ventilatorConnected && user_enabled && ventilationStatus && props?.ventilatorAlarmData?.length > 0 ?
                            <div className={`alarm-container ${getAlarmPriorityClass(props.ventilatorAlarmData[0])}`}
                                onClick={(event) => handleShowMoreVentilatorAlarmsClick(event)}
                                id="alarm-display-bar"
                            >
                                <div className="top-alarm-container">
                                    {props.ventilatorAlarmData[0].name}
                                </div>
                                <div className="alarm-number-container">
                                    {props.ventilatorAlarmData.length}
                                    {showMoreVentilatorAlarms ?
                                        <img src={props.ventilatorAlarmData[0].priority?.toLocaleUpperCase() === "HIGH" ? whiteUpArrow : blackUpArrow} className="arrow-icon" alt="white up arrow" />
                                        :
                                        <img src={props.ventilatorAlarmData[0].priority?.toLocaleUpperCase() === "HIGH" ? whiteDownArrow : blackDownArrow} className="arrow-icon" alt="white down arrow" />
                                    }
                                </div>
                                {showMoreVentilatorAlarms &&
                                    <div className="more-alarm-container">
                                        {
                                            props?.ventilatorAlarmData?.map((alarm, count) => {
                                                if (count > 3) return;
                                                return (
                                                    <div className="alarm more-alarm" key={count}>
                                                        {alarm.name}
                                                        <span className="alarm-time">{alarm.time && moment(alarm.time, "YYYYMMDDHHmmss").format("HH:mm:ss")}</span>
                                                    </div>);
                                            })
                                        }
                                        <div className="see-all-container" onClick={() => props.handleAlarmMoreClick()}>
                                            See all
                                        </div>
                                    </div>
                                }
                            </div>
                            :
                            <div className="alarm-container no-alarm"
                                id="no-alarm-display-bar"
                            >
                                <div className="top-alarm-container">
                                    No active alarms
                                </div>
                            </div>
                        }
                    </div>


                    <div className={`device-ventilator-data ${props?.bedDetails?.ventilatorId ? '' : 'not-connected'}`}>
                        {BED_CARD_VITALS.VENTILATOR.map((vital) => {
                            // Find the corresponding vital data
                            const vitalData = Object.values(props?.ventilatorData?.ventilatorVitalData?.basic_params || {})
                                .find(p => p?.id === vital?.id);

                            // Check if unit exists
                            const hasValidUnit = PARAMETER_UNIT_IDS?.[vitalData?.unit]?.UNIT != null;

                            // Alarm background class
                            const alarmClass = hasValidUnit && ventilatorConnected && user_enabled && ventilationStatus && vitalData?.alarms?.length
                                ? alarmBackground(vitalData.alarms)
                                : "";

                            const formatValue = (num) => {
                                if (num == null || isNaN(num)) return "--";

                                const truncated = num * 100;

                                if (truncated % 100 === 0) {
                                    return num.toString(); // integer, no decimals
                                }
                                else if (truncated % 10 === 0) {
                                    // 1 decimal
                                    const numStr = num.toString();
                                    const [intPart, decPart] = numStr.split(".");
                                    return intPart + "." + (decPart ? decPart[0] : "0");
                                }
                                else {
                                    // 2 decimals
                                    const numStr = num.toString();
                                    const [intPart, decPart] = numStr.split(".");
                                    return intPart + "." + (decPart ? decPart.slice(0, 2) : "00");
                                }
                            };

                            // Title and unit safely
                            const title = ACTIVE_PARAMETERS?.[vital?.id]?.TITLE ?? "-";
                            const unit = hasValidUnit ? PARAMETER_UNIT_IDS?.[vitalData?.unit]?.UNIT ?? "-" : "-";

                            // Value formatting
                            const value = hasValidUnit && vitalData?.value != null
                                ? formatValue(vitalData.value)
                                : "-";

                            return (
                                <div
                                    key={vital?.id}
                                    className={`vital-data-detail ${vital?.id === 104008 ? "wide-field" : ""} ${alarmClass}`}
                                >
                                    <div className="vital-name">{title}</div>
                                    <div className="vital-data">
                                        {ventilatorConnected && user_enabled && ventilationStatus ? value : "-"}
                                        <div className="unit">{unit}</div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BedCardDesktopView;
